import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from "isomorphic-style-loader/withStyles";
import cx from 'classnames';

import s from './Skeleton.css';

const Shimmer = () => {
    return (
        <div className={cx(s.shimmerWrapper, 'kindTripBorder', 'newsBoxBorder')}>
            <div className={s.shimmer}></div>
        </div>
    )
}

export default compose(withStyles(s))(Shimmer);